import { get } from '../helpers/api';

export const AUTH_SERVICE_URI = '/users';
export const AUTH_BASE_URI = '/api/v1/roles';

export const getRolesWithDetails = async () =>
  get(`${AUTH_SERVICE_URI}${AUTH_BASE_URI}/passenger`);
